import { Card, CardBody, Col, Row } from "reactstrap";
import CommonCardHeader from "../../../../CommonComponents/CommonCardHeader/CommonCardHeader";
import { BlogGridListData } from "../../../../../Data/Miscellaneous/Blog";
import { H6, LI, P, UL } from "../../../../../AbstractElements";
import { Link } from "react-router-dom";
import { LatestNewsAndTrendsTitle } from "../../../../../Constants/Constants";

const LatestNewsAndTrends = () => {
  return (
    <Col sm="12">
      <Card>
        <CommonCardHeader title={LatestNewsAndTrendsTitle} headClass="pb-20" />
        <CardBody>
          <Row className="gy-3">
            {BlogGridListData.map((item, index) => (
              <Col xxl="6" xl="12" md="6" key={index}>
                <div className="blog-card">
                  <H6>{item.title}</H6>
                  <P>{item.content}</P>
                  <div className="post-social">
                    <UL className="d-flex align-items-center simple-list flex-row">
                      <LI className="bg-light-primary txt-primary">{item.date}</LI>
                      <LI className="bg-light-secondary txt-secondary">
                        <i className="fa fa-user mx-1" />
                        {item.author}
                      </LI>
                      <LI className="bg-light-info txt-info">
                        <i className="fa fa-comments mx-1" />
                        {item.comments}
                      </LI>
                    </UL>
                  </div>
                  <Link className="btn" to={`${process.env.PUBLIC_URL}/blog/blog_Details`}>
                    View more
                    <i className="fa fa-long-arrow-right" />
                  </Link>
                </div>
              </Col>
            ))}
          </Row>
        </CardBody>
      </Card>
    </Col>
  );
};

export default LatestNewsAndTrends;
